import { debounce } from "lodash";
import { useEffect, useMemo, useState } from "react";
import { TEST_TYPES } from "../../../../constants";
import {
  Radio,
  SearchableSelect,
  TextField,
  Typography,
} from "../../../components";
import classNames from "classnames";
import { BinaryMultiSelect } from "./BinaryMultiSelect";
import "./styles.scss";

function TestItem(props) {
  const {
    item,
    onChange = () => {},
    initialValue,
    groupId = "",
    disabled = false,
    ...rest
  } = props;
  const [value, setValue] = useState(initialValue);

  const selectOptions = useMemo(() => {
    return [...Array(item.values)].map((_, i) => ({
      value: i,
      label: item[`v${i + 1}`],
    }));
  }, [item]);

  useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);

  const debounceCallback = useMemo(
    () => debounce((data, isTextInput) => onChange(data, isTextInput), 100),
    [onChange]
  );

  function updateValueState(e) {
    setValue(e.target.value);
    return { [`${item.dbColumn}`]: e.target.value };
  }

  function onValueChange(e) {
    const data = updateValueState(e);
    debounceCallback(data);
  }

  function onTextInputValueChange(e) {
    const data = updateValueState(e);
    debounceCallback(data, true);
  }

  return (
    <div
      {...rest}
      className={classNames(rest.className, { "tg_item--disabled": disabled })}
    >
      {item.type === TEST_TYPES.SUB_HEADING ? (
        <div
          className="tg_info tg_test-sub-heading-html"
          dangerouslySetInnerHTML={{ __html: item.text }}
        ></div>
      ) : (
        <>
          <Typography h1>{item.text}</Typography>
          {item.type === TEST_TYPES.LIKERT && (
            <div className="tg_radio-group-wrapper">
              <Typography h3 className="tg_group-title">
                {item[`v${1}`]}
              </Typography>
              <div className="tg_radio-group">
                {[...Array(item.values)].map((_, i) => (
                  <Radio
                    key={i}
                    name={`radio-${groupId}${item._id}`}
                    checked={value === (i + 1).toString()}
                    onChange={onValueChange}
                    label={item[`v${i + 1}`]}
                    value={i + 1}
                    disabled={disabled}
                  />
                ))}
              </div>
              <Typography h3 className="tg_group-title">
                {item[`v${item.values}`]}
              </Typography>
            </div>
          )}
          {item.type === TEST_TYPES.CHOICE && (
            <SearchableSelect
              name={`select-${groupId}${item._id}`}
              value={value}
              onChange={onValueChange}
              options={selectOptions}
              disabled={disabled}
            />
          )}
          {item.type === TEST_TYPES.NUMERICAL && (
            <TextField
              name={`number-${groupId}${item._id}`}
              type="number"
              value={value}
              onChange={onValueChange}
              disabled={disabled}
            />
          )}
          {item.type === TEST_TYPES.TEXT && (
            <TextField
              name={`textarea-${groupId}${item._id}`}
              textarea
              rows="6"
              value={value}
              onChange={onTextInputValueChange}
              disabled={disabled}
            />
          )}
          {item.type === TEST_TYPES.MULTI_CHOICE && (
            <div className="tg_multi-select-wrapper">
              <BinaryMultiSelect
                options={selectOptions}
                onChange={onValueChange}
                value={value}
                disabled={disabled}
              />
            </div>
          )}
        </>
      )}
    </div>
  );
}

export default TestItem;
